import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PortalAccountsUserTaskTable from './portal-accounts-table-user-task.jsx';
import JobsTable from '../jobs/jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-portal-admin-all-portal-users-task-list')) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/portal-admin/all-portal-users-task"
    message_if_none = 'No portal accounts yet.'
  />,
document.getElementById('react-component-g4-logistics-portal-portal-admin-all-portal-users-task-list'));
}
